export class UpperCaseValueConverter {
    fromView(value:string) {
        return (value || "").toUpperCase();
    }
    toView(value:string) {
        return (value || "").toUpperCase();
    }
}